import { useGetSalesRepHistoryCursorInfiniteQuery } from '@/services/salesReps';
import { Box, Spinner } from '@palmetto/palmetto-components';

import { InfiniteActivityList } from '../Activity/InfiniteActivityList';

const PAGE_SIZE = 20;

export const SalesRepHistoryView = () => {
  const { data, fetchNextPage, isLoading, isFetchingNextPage, hasNextPage, isError } =
    useGetSalesRepHistoryCursorInfiniteQuery(undefined, {
      initialPageParam: { limit: PAGE_SIZE, cursor: undefined },
    });

  if (isError) {
    return (
      <Box padding="lg" textAlign="center" color="danger">
        Failed to load sales rep history.
      </Box>
    );
  }

  const activities = data?.pages.flatMap((page) => page.data) ?? [];

  return (
    <Box padding="lg">
      {isLoading ? (
        <Spinner size="lg" />
      ) : (
        <InfiniteActivityList
          activities={activities}
          fetchNextPage={fetchNextPage}
          isLoading={isFetchingNextPage}
          hasMore={hasNextPage ?? false}
        />
      )}
    </Box>
  );
};
